import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
  Polygon
} from "@react-google-maps/api";
import useGetGrievances from "./useGetGrievances";
import indiaShape from "../../../../src/assets/geoJsonData/india-composite.json";
import { mapStyles } from "../../../utils/mapStyles";

import { priorityIcons } from "../../../utils/priorityIcons";
import { statusIcons } from "../../../utils/statusIcons";
import MarkerInfoContent from "./MarkerInfoContent";
import {
  lib,
  indiaCenter,
  initialZoom,
  indiaBounds
} from "../../../utils/mapConstants";
import useGeoData from "../../../Components/cdm/Parliamentary/ParliamentaryMap/useGeoData";
// import useProcessGeoData from "../../../Components/cdm/AssemblyMap/useProcessGeoData";
import useProcessGeoData from "../../../Components/cdm/Parliamentary/ParliamentaryMap/useProcessGeoData";
import { Select } from "antd";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { useQuery } from "react-query";

const loggedInUser=JSON.parse(localStorage.getItem("user"))

const MapBox = (props) => {
  const axiosInstance = useAxiosInstance();
  const { priorityClick, statusClick, newGrievanceData,constituencyData,villagesList } = props;

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: lib
  });
  const { grievances, loading } = useGetGrievances(
    isLoaded,
    priorityClick,
    statusClick,
    newGrievanceData
  );
  const [activeMarker, setActiveMarker] = useState(null);
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
   const [polygonPaths, setPolygonPaths] = useState([]); 
   const [selectedMarker,setSelectedMarker]=useState({})
  const constituencyDataType=constituencyData?.data?.type;
  const [polyData, setPolyData] = useGeoData(constituencyData?.data?._id); 
  const [fetchedData,setFetchedData]= useState([])

  const mapRef = useRef(null);

  useEffect(() => {
      const fetchBoundariesByPcName = async () => {
        if (polyData[0]?.state && polyData[0]?.name) {
          try {
            const response = await axiosInstance.get(
              `api/constituency/getAllConstituency?state=${polyData[0].state.toUpperCase()}&district=${polyData[0].name}&parliamentary=parliamentary`
            );
            const fetchedData = response?.data?.data || [];
            setFetchedData?.(fetchedData);
          } catch (error) {
            console.error("Failed to fetch parliamentary data:", error);
          }
        }
      };
  
      if (isLoaded) {
        fetchBoundariesByPcName();
      }
    }, [polyData[0]?.state, polyData[0]?.name, isLoaded]);

  useProcessGeoData(fetchedData, isLoaded, setPolygonPaths);

   useEffect(() => {
      if (
        polygonPaths &&
        Array.isArray(polygonPaths) &&
        polygonPaths.length > 0
      ) {
        const bounds = new window.google.maps.LatLngBounds();
        polygonPaths.forEach((polygon) => {
          polygon?.coordinate.forEach((item) => {
            bounds.extend(new window.google.maps.LatLng(item?.lat, item?.lng));
          });
        });
        const polygonCenter = bounds.getCenter();
        mapRef.current.fitBounds(bounds);
        mapRef.current.setCenter(polygonCenter);
      }
    }, [polygonPaths,constituencyData]);

  const fetchGrievanceInsightsByUserRole = async (villageId) => {
    let response;
    if(villageId){
      response = await axiosInstance.get(`api/grievances/grievanceInsightsByUserRole${villageId ? `?villageId=${villageId}` : ""}`);
    }
    else{
      response = await axiosInstance.get(`api/grievances/grievanceInsightsByUserRole`);
    }
    
    return response || [];
  };

  const {
    data: grievanceInsightsDataByRole,
    isLoading: insightsLoading,
    error: insightsError
  } = useQuery(
    ["insights-data", selectedMarker?._id || "all"], // use "all" for no village
    () => fetchGrievanceInsightsByUserRole(selectedMarker?._id),
    {
      refetchOnWindowFocus: false, // prevent aggressive reloading
      retry: 1,
    }
  );

   const fetchGrievanceInsightsByOffice = async (villageId) => {
    let response;
    if(villageId){
      response = await axiosInstance.get(`api/grievances/grievanceInsightsByOffice${villageId ? `?villageId=${villageId}` : ""}`);
    }
    else{
      response = await axiosInstance.get(`api/grievances/grievanceInsightsByOffice`);
    }
    
    return response || [];
  };

  const {
    data: grievanceInsightsDataByOffice,
    isLoading: insightsOfficeLoading,
    error: insightsOfficeError
  } = useQuery(
    ["insights-data-office", selectedMarker?._id || "all"], // use "all" for no village
    () => fetchGrievanceInsightsByOffice(selectedMarker?._id),
    {
      refetchOnWindowFocus: false, // prevent aggressive reloading
      retry: 1,
    }
  );

  const onCloseInfoWindow = () => {
    setActiveMarker(null);
    setShowingInfoWindow(false);
    const numSteps = 10;
    const targetZoom=10;
    const currentZoom = mapRef.current.getZoom();
    const step = (targetZoom - currentZoom) / numSteps;
    // Smoothly zoom out
    for (let i = 1; i <= numSteps; i++) {
      setTimeout(() => {
        const newZoom = currentZoom + step * i;
        // mapRef.current.setZoom(7);
        mapRef.current.setZoom(newZoom);
      }, 80 * i);
      }
   
  };

  const onMarkerClick = (marker) => {
    setActiveMarker(marker);
    setShowingInfoWindow(true);

    const markerLatLng = new window.google.maps.LatLng(
      marker.geometry.coordinates[1],
      marker.geometry.coordinates[0]
    );
    if (mapRef.current) {
      const targetZoom = 15;
      const currentZoom = mapRef.current.getZoom();
      const numSteps = 10;
      const step = (targetZoom - currentZoom) / numSteps;

      // Smoothly zoom in
      for (let i = 1; i <= numSteps; i++) {
        setTimeout(() => {
          const newZoom = currentZoom + step * i;
          mapRef.current.setZoom(newZoom);
          mapRef.current.panTo(markerLatLng);
        }, 80 * i);
      }
    }
  };

  const onLoad = (map) => {
    mapRef.current = map;
    map.data.addGeoJson(indiaShape);
    map.data.setStyle((feature) => {
      return {
        fillColor: "white",
        fillOpacity: 0.1,
        strokeColor: "black",
        strokeWeight: 1,
        strokeOpacity: 0.1
      };
    });
  };

  const renderInfoWindow = () => {
    if (activeMarker && showingInfoWindow)
      return (
        <InfoWindow
          position={{
            lat: activeMarker?.geometry?.coordinates?.[1],
            lng: activeMarker?.geometry?.coordinates?.[0]
          }}
          visible={showingInfoWindow}
          onCloseClick={onCloseInfoWindow}
        >
          <MarkerInfoContent activeMarker={activeMarker} />
        </InfoWindow>
      );
  };

  const renderGrievanceMarkers = () => {
    return grievances.map((grievance, index) => {
      const coordinates = grievance?.geometry?.coordinates;
      if (
        coordinates &&
        coordinates.length === 2 &&
        typeof coordinates[0] === "number" &&
        typeof coordinates[1] === "number" &&
        grievance?.properties?.status !== "complete"
      ) {
        return (
          <Marker
            icon={{
              url: statusIcons[grievance?.properties?.status],
              scaledSize: new window.google.maps.Size(30, 30),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15)
            }}
            key={index}
            title={grievance?.properties?.title || "No Title"}
            position={{
              lat: coordinates[1],
              lng: coordinates[0]
            }}
            onClick={() => {
              onMarkerClick(grievance);
            }}
          />
        );
      } else {
        return null;
      }
    });
  };

  const renderConstituencyPolygons = () => {
    if (!polygonPaths || !Array.isArray(polygonPaths)) return null;
    return polygonPaths.map((polygon, index) => {
      const bounds = new window.google.maps.LatLngBounds();
      polygon?.coordinate.forEach((point) => {
          const lat = Number(point?.lat);
          const lng = Number(point?.lng);
          if (!isNaN(lat) && !isNaN(lng)) {
              bounds.extend({ lat, lng });
          } else {
              console.error("Invalid coordinateP:", point?.lat);
          }
        });
        const center = bounds.getCenter();

      return (
        <React.Fragment key={index}>
          <Polygon
            key={index}
            paths={polygon?.coordinate
                  ?.map((point) => ({
                    lat: Number(point?.lat),
                    lng: Number(point?.lng)
                  }))
                  .filter((point) => !isNaN(point.lat) && !isNaN(point.lng))}
            options={{
              strokeColor: "#810FCB",
              strokeOpacity: 1.0,
              strokeWeight: 2,
              fillColor: "#810FCB",
              fillOpacity: 0.5
            }}
          />
        </React.Fragment>
        
      );
    });
  };

  const handleVillageSelectChange = (id) => {
    const newMarker = villagesList?.data?.data?.data.find((item) => item?._id === id);
    if (newMarker) {
      setSelectedMarker(newMarker);
    }
  };

  const nameMap = {
  client: "Client",
  data_entry_operator: "DEO",
  constituency_manager: "Constituency Manager",
  office_manager: "Office Manager",
  chief_of_staff: "Chief of Staff",
  cadre:"Cadre"
};

  if (loadError) {
    return <div className='loader'>Error loading the map</div>;
  }

  if (isLoaded) {
    return (
      <>
        {loading && (
          <div className='loader'>
            <div>Loading...</div>
          </div>
        )}
        <div className=" max-w-xs z-10 mt-6 ml-6 flex items-center">
            <Select
              id='villageSelect'
              placeholder={"Select" + " " + "village/ward"}
              value={selectedMarker?.village_id}
              onChange={handleVillageSelectChange}
              className='mr-4'
              showSearch // Enable showSearch
              optionFilterProp='children' // Specify the property to filter on
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {(villagesList?.data?.data?.data || [])
                .filter(village => village.villageName) // Optional: filter out unnamed villages
                .sort((a, b) => {
                  const nameA = a.villageName || '';
                  const nameB = b.villageName || '';
                  return nameA.localeCompare(nameB);
                })
                .map((village) => (
                  <Select.Option key={village?._id} value={village?._id}>
                    {village?.villageName || 'Unnamed Village'}
                  </Select.Option>
                ))}
            </Select>
          </div>
        <div className='flex map-container1 '>
          <GoogleMap
            google={props.google}
            zoom={initialZoom}
            mapContainerClassName='map-container'
            // center={indiaCenter}
            options={{
              styles: mapStyles,
              restriction: {
                latLngBounds: indiaBounds,
                strictBounds: true
              }
            }}
            onLoad={onLoad}
            ref={mapRef}
          >
            {renderConstituencyPolygons()}
            {renderGrievanceMarkers()}
            {renderInfoWindow()}
          </GoogleMap>
          <div className="flex flex-col w-full max-w-2xl pl-6 pr-6">
             <div className="flex justify-between items-center mb-4 bg-[#EFF6FF] rounded-full">
                <h3 className="bg-[#EFF6FF] text-blue-800 text-xl font-semibold px-4 py-1 rounded-full shadow-sm">
                  Insights
                </h3>
                <span className="bg-[#095689] text-[#fff] text-l font-bold px-3 py-1 rounded-full">
                  {loggedInUser?.role?.toUpperCase()}
                </span>
            </div>
            {insightsLoading ? (
              <p>Loading insights...</p>
            ) : insightsError ? (
              <p>Error loading insights</p>
            ) : (
             <div className="bg-white rounded-xl border border-gray-200 shadow p-3 mb-6">
              <div className="bg-gray-100 text-center text-xl font-semibold py-1 rounded-t-md mb-2">
                Grievance count by Users
              </div>
              <div className="divide-y">
                {grievanceInsightsDataByRole?.data?.message?.data?.map((item, index) => {
                  const userName = item._id?.name || "Unknown";
                  const userRoleKey = item._id?.role?.toLowerCase();
                  const formattedRole =
                    nameMap[userRoleKey] ||
                    userRoleKey
                      ?.split("_")
                      .map((word, i) =>
                        i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join("");

                  return (
                    <div
                      key={index}
                      className="flex justify-between items-center px-3 py-2 text-l"
                    >
                      <div className="flex flex-col">
                        <span className="font-medium table-color">{userName}</span>
                        <span className="text-xs text-gray-500">{formattedRole}</span>
                      </div>
                      <span className="text-l font-bold table-color">
                        {item.count}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            )}
            {insightsOfficeLoading ? (
              <p>Loading insights...</p>
            ) : insightsOfficeError ? (
              <p>Error loading insights</p>
            ) : (
              <div className="bg-white rounded-xl border border-gray-200 shadow p-3">
                <div className="bg-gray-100 text-center text-xl font-semibold py-1 rounded-t-md mb-2">
                  Office Assigned
                </div>
                <div className="divide-y">
                  {grievanceInsightsDataByOffice?.data?.message?.data?.map((item, index) => {
                    const officeName = item.officeName || "Unknown";
                    const officeId = item.officeId;

                    return (
                      <div
                        key={officeId}
                        className="flex justify-between items-center px-3 py-2 text-l"
                      >
                        <div className="flex flex-col">
                          <span className="font-medium table-color">{officeName}</span>
                        </div>
                        <span className="text-l font-bold table-color">
                          {item.count}
                        </span>
                      </div>
                    );
                  })}
                </div>
    </div>
            )}
          </div>
         
        </div>
      </>
    );
  } else {
    return <div className='loader'>Loading...</div>;
  }
};

export default MapBox;
